globalThis.jotaiAtomCache = globalThis.jotaiAtomCache || {
  cache: new Map(),
  get: function get(name, inst) {
    if (this.cache.has(name)) {
      return this.cache.get(name);
    }

    this.cache.set(name, inst);
    return inst;
  }
};
import _styled from "styled-components";
import Image from 'next/image';
import { useTranslation } from 'next-i18next';
import { customImageLoader, formatDateToDayMonthYear } from '@restworld/utils-common';
import LinkBase from '../link-base';
import Badge from '../badge';
import Title from '../title';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function WorkerBaseCard(_ref) {
  var variant = _ref.variant,
      badges = _ref.badges,
      city = _ref.city,
      firstSubDate = _ref.firstSubDate,
      logoSrc = _ref.logoSrc,
      venueName = _ref.venueName;
  return /*#__PURE__*/_jsxs(CardWrapper, {
    variant: variant,
    children: [/*#__PURE__*/_jsx(CardJpDetails, {
      badges: badges
    }), /*#__PURE__*/_jsx(CardVenueDetails, {
      variant: variant,
      logoSrc: logoSrc,
      city: city,
      firstSubDate: firstSubDate,
      venueName: venueName
    }), /*#__PURE__*/_jsx(CardSubscriptionDetails, {
      firstSubDate: firstSubDate
    })]
  });
}
export default WorkerBaseCard;
export function CardWrapper(_ref2) {
  var children = _ref2.children,
      variant = _ref2.variant,
      newTab = _ref2.newTab,
      onClick = _ref2.onClick,
      wrapperStyle = _ref2.wrapperStyle,
      _ref2$href = _ref2.href,
      href = _ref2$href === void 0 ? '#!' : _ref2$href;
  return /*#__PURE__*/_jsx(Wrapper, {
    link: href,
    variant: variant,
    newTab: newTab,
    onLinkClick: onClick,
    twStyle: wrapperStyle,
    children: children
  });
}
export function CardJpDetails(_ref3) {
  var badges = _ref3.badges,
      title = _ref3.title;
  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsx(CardTitle, {
      content: title
    }), /*#__PURE__*/_jsx(_StyledDiv, {
      children: !!(badges !== null && badges !== void 0 && badges.length) && badges.map(function (badge) {
        return /*#__PURE__*/_jsx(_StyledBadge, {
          variant: "fresh",
          children: badge
        }, badge);
      })
    })]
  });
}
export function CardVenueDetails(_ref4) {
  var logoSrc = _ref4.logoSrc,
      variant = _ref4.variant,
      city = _ref4.city,
      firstSubDate = _ref4.firstSubDate,
      venueName = _ref4.venueName,
      isOutsideItaly = _ref4.isOutsideItaly;
  var isJpVariant = variant === 'jp';
  var isVenueVariant = variant === 'venue';
  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsxs(_StyledDiv2, {
      children: [logoSrc && /*#__PURE__*/_jsx(_StyledDiv3, {
        children: /*#__PURE__*/_jsx(Image, {
          alt: "",
          loader: customImageLoader,
          fill: true,
          src: logoSrc
        })
      }), /*#__PURE__*/_jsxs("div", {
        children: [isJpVariant && /*#__PURE__*/_jsx(Title, {
          content: venueName,
          fontWeight: "medium",
          textColor: "neutral-700",
          twStyle: {
            "fontSize": "0.875rem !important",
            "lineHeight": "1.25rem !important"
          }
        }), /*#__PURE__*/_jsxs(_StyledDiv4, {
          children: [city && /*#__PURE__*/_jsx(Title, {
            icon: isOutsideItaly ? 'WorldIcon' : 'MapPinIconNeutral700',
            content: city,
            fontWeight: "medium",
            textColor: "neutral-700",
            twStyle: {
              "maxWidth": "200px",
              "fontSize": "0.875rem !important",
              "lineHeight": "1.25rem !important"
            }
          }), isJpVariant && firstSubDate && /*#__PURE__*/_jsx(Title, {
            icon: "CalendarIcon",
            content: formatDateToDayMonthYear(firstSubDate),
            fontWeight: "medium",
            textColor: "neutral-700",
            twStyle: {
              "fontSize": "0.875rem !important",
              "lineHeight": "1.25rem !important"
            }
          })]
        })]
      })]
    }), isVenueVariant && /*#__PURE__*/_jsx(CardTitle, {
      content: venueName,
      twStyle: {
        "marginTop": "0.5rem"
      }
    })]
  });
}
export function CardSubscriptionDetails(_ref5) {
  var firstSubDate = _ref5.firstSubDate;

  var _useTranslation = useTranslation('common'),
      t = _useTranslation.t;

  if (!firstSubDate) return null;
  return /*#__PURE__*/_jsx(Title, {
    content: t('subscribed_since_date', {
      date: formatDateToDayMonthYear(firstSubDate)
    }),
    fontWeight: "medium",
    textColor: "neutral-700",
    twStyle: {
      "fontSize": "0.875rem !important",
      "lineHeight": "1.25rem !important"
    }
  });
}

function CardTitle(_ref6) {
  var content = _ref6.content,
      twStyle = _ref6.twStyle;
  return /*#__PURE__*/_jsx(Title, {
    content: content,
    textColor: "black",
    fontWeight: "medium",
    twStyle: [{
      "maxWidth": "288px",
      "fontSize": "1.125rem !important",
      "lineHeight": "1.75rem !important"
    }, twStyle || {}],
    maxChars: 78
  });
}

var Wrapper = /*#__PURE__*/_styled(LinkBase).withConfig({
  displayName: "worker-base-card__Wrapper",
  componentId: "sc-1t2wuyv-0"
})(["", ";", " ", ";"], {
  "display": "flex",
  "width": "fit-content",
  "minWidth": "320px",
  "maxWidth": "640px",
  "flexDirection": "column",
  "gap": "2rem",
  "borderRadius": "1rem",
  "borderWidth": "1px",
  "padding": "1rem",
  "transitionProperty": "all",
  "transitionTimingFunction": "cubic-bezier(0.4, 0, 0.2, 1)",
  "transitionDuration": "150ms"
}, function (_ref7) {
  var variant = _ref7.variant;
  return variant === 'jp' ? {
    "--tw-border-opacity": "1",
    "borderColor": "rgb(102 51 187 / var(--tw-border-opacity))",
    "backgroundColor": "rgb(102 51 187 / 0.1)",
    "outlineColor": "#6633bb",
    ":hover": {
      "backgroundColor": "rgb(102 51 187 / 0.15)",
      "--tw-shadow": "inset 0 0 0 1px #6633bb",
      "--tw-shadow-colored": "inset 0 0 0 1px var(--tw-shadow-color)",
      "boxShadow": "var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow)"
    }
  } : variant === 'venue' ? {
    "--tw-border-opacity": "1",
    "borderColor": "rgb(133 133 145 / var(--tw-border-opacity))",
    "backgroundColor": "rgb(0 0 26 / 0.05)",
    "outlineColor": "#858591",
    ":hover": {
      "backgroundColor": "rgb(0 0 26 / 0.15)",
      "--tw-shadow": "inset 0 0 0 1px #858591",
      "--tw-shadow-colored": "inset 0 0 0 1px var(--tw-shadow-color)",
      "boxShadow": "var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow)"
    }
  } : {};
}, function (_ref8) {
  var twStyle = _ref8.twStyle;
  return twStyle || {};
});

var _StyledDiv = /*#__PURE__*/_styled("div").withConfig({
  displayName: "worker-base-card___StyledDiv",
  componentId: "sc-1t2wuyv-1"
})({
  "marginTop": "0.5rem",
  "display": "flex",
  "maxWidth": "288px",
  "flexWrap": "wrap",
  "alignItems": "center",
  "gap": "0.5rem"
});

var _StyledBadge = /*#__PURE__*/_styled(Badge).withConfig({
  displayName: "worker-base-card___StyledBadge",
  componentId: "sc-1t2wuyv-2"
})({
  "width": "fit-content"
});

var _StyledDiv2 = /*#__PURE__*/_styled("div").withConfig({
  displayName: "worker-base-card___StyledDiv2",
  componentId: "sc-1t2wuyv-3"
})({
  "display": "flex",
  "alignItems": "center",
  "gap": "0.75rem"
});

var _StyledDiv3 = /*#__PURE__*/_styled("div").withConfig({
  displayName: "worker-base-card___StyledDiv3",
  componentId: "sc-1t2wuyv-4"
})({
  "position": "relative",
  "height": "43px",
  "width": "43px",
  "overflow": "hidden",
  "borderRadius": "0.5rem",
  "borderWidth": "1px",
  "--tw-border-opacity": "1",
  "borderColor": "rgb(133 133 145 / var(--tw-border-opacity))"
});

var _StyledDiv4 = /*#__PURE__*/_styled("div").withConfig({
  displayName: "worker-base-card___StyledDiv4",
  componentId: "sc-1t2wuyv-5"
})({
  "display": "flex",
  "gap": "0.75rem"
});